

  
  const degrees = {
    degrees: [
      {
        title: "Cooch Behar Government Engineering College",
        subtitle: "B.Tech. in Electronics and Communication Engineering",
        alt_name: "Coochbehar College",
        duration: "2019 - Present",
        descriptions: [
          "⚡ I have studied basic software engineering subjects like DS, Algorithms, DBMS & COA.",
          "⚡ Apart from this, I have done courses on Full Stack Web Development, Algorithimic Toolbox, Machine Learning.",
        ],
        website_link: "http://cgec.org.in/",
      },
    ],
  };
  
  const certifications = {
    certifications: [
      {
        title: "Machine Learning",
        subtitle: "- Andrew Ng",
        logo_path: "CertificatePic/Coursera.svg",
        certificate_link:
          "https://www.coursera.org/account/accomplishments/verify/D5NKCF27W42T",
        alt_name: "Stanford University",
        color_code: "#8C151599",
      },
      {
        title: "Algorithimic Toolbox",
        subtitle: "-University of California San Diego",
        logo_path: "CertificatePic/Coursera.svg",
        certificate_link:
          "https://www.coursera.org/account/accomplishments/verify/F9LCYFS3GECS",
        alt_name: "Coursera",
        color_code: "#1F70C199",
      },
      {
        title: "HTML,JavaScript,Bootstrap",
        subtitle: "-YouAccle Training",
        logo_path: "CertificatePic/Udemy2.svg",
        certificate_link:
          "https://udemy-certificate.s3.amazonaws.com/image/UC-4545805b-df9a-4d41-989d-e9dfc589590f.jpg",
        alt_name: "Udemy",
        color_code: "#00000",
      },
      {
        title: "The Complete Web Developer in 2021: Zero to Mastery",
        subtitle: "- Andrei Neagoie",
        logo_path: "CertificatePic/Udemy2.svg",
        certificate_link:
          "https://udemy-certificate.s3.amazonaws.com/image/UC-b642ab55-42b4-4333-8437-fdcba03faf5f.jpg",
        alt_name: "Udemy",
        color_code: "#00000",
      },
      {
        title: "Problem Solving through programming in C",
        subtitle: "- Prof.Adrijit Goswami",
        logo_path: "CertificatePic/Nptel.png",
        certificate_link:
          "https://nptel.ac.in/content/noc/NOC20/SEM1/Ecertificates/106/noc20-cs06/Assignment/Certificates/NPTEL20CS06S1PC828057.jpg",
        alt_name: "NPTEL",
        color_code: "#D83B0199",
      },
      {
        title: "Problem Solving Basic",
        subtitle: "- Hackerrank",
        logo_path: "CertificatePic/hackerrank.svg",
        certificate_link:
          "https://www.hackerrank.com/certificates/6288b59151d3",
        alt_name: "Hackerrank",
        color_code: "#0C9D5899",
      },
      {
        title: "JavaScript Basic",
        subtitle: "- Hackerrank",
        logo_path: "CertificatePic/hackerrank.svg",
        certificate_link:
          "https://www.hackerrank.com/certificates/b5e49b4454fe",
        alt_name: "Hackerrank",
        color_code: "#0C9D5899",
      },
    ],
  };
  const experience = {
    title: "Experience",
    description:
      `Till now I have only the experience of contributing to open source.
      But would love to work as a SDE intern, also learning ML to enrich my skills,
      solved around 250+ problems in Leetcode ,also a 3star in codechef 
      [-max-rating:1726] and Newbie in 
      Codeforces[-max-rating:953] `,
    header_image_path: "experience.svg",
    sections: [
      {
        title: "Work",
        experiences: [
          {
            title: "Open Source Contributor",
            company: "LetsGrowMore",
            company_url: "https://lgmsoc.co/",
            logo_path: "legato_logo.png",
            duration: "June 2021-August 2021",
            description:
              `LGMSOC'21 is the 2 month Open Source Program during summers conducted by Lets grow more Foundation.

              There were multiple Projects in Web development and Data science which were open for contribution with different Projects
              Contributed to 5 different projects with React js as the tech stack
              . Succesfully merged 4PR's of level 4.`,
            color: "#9b1578",
          },
        ],
      },
    ],
  }
  const contactPageData = {
    contactSection: {
      title: "Contact Me",
      profile_image_path: "animated_ashutosh.png",
      description:
        `I am available on almost every social media. You can message me, 
        I will reply within 24 hours. I can help you with React, 
        Opensource and Web Dev.`,
    },
    blogSection: {
      title: "Blogs",
      subtitle:
        "For individual fundamental empowerment, I like to write powerful lessons that create impact on each of the reader individually to change the core of their character.",
      link: "https://medium.com/@banerjeerajbir2888",
    },
    addressSection: {
      title: "Address",
      subtitle:
        "Coke Oven Colony Qtr No. :- EN-109, Durgapur 713202 ,West Bengal",
    },
    phoneSection: {
      title: "Phone Number",
      subtitle: "+91 8250905622",
    },
  };
  const greeting = {
    title: "",
    logo_name: "",
    nickname: "",
    subTitle:
      "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
    resumeLink:
      "https://drive.google.com/file/d/1GbqBHw5-1230UYLOQgdL83Uu4SfzFUdV/view?usp=sharing",
    portfolio_repository: "",
  };
  
export {
  degrees,
  certifications,
  experience,
  contactPageData,
  greeting
}  